import React from "react";
import { connect } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { colors } from "../../assets/theme/colors";
import { typography } from "../../assets/theme/typography";
import { useNavigate } from "react-router-dom";
import "./dashboard.scss";

const statusStyles = {
  "Pending Approval": {
    color: "#A76500",
    background: "#FFE9A9",
  },
  "Pending Finance": {
    color: "#1264C8",
    background: "#DDEBFF",
  },
  Submitted: {
    color: "#1264C8",
    background: "#DDEBFF",
  },
  Draft: {
    color: "#4B5563",
    background: "#E5E7EB",
  },
  Approved: {
    color: "#067647",
    background: "#DDF4E7",
  },
  Paid: {
    color: "#0E7490",
    background: "#D8F3F6",
  },
};

const dashboardData = {
  summary: [
    {
      label: "Pending Travel Requests",
      value: 18,
      change: "4 from last 7 days",
      icon: "mdi:briefcase-outline",
    },
    {
      label: "Pending Claims",
      value: 12,
      change: "3 from last 7 days",
      icon: "mdi:file-document-outline",
    },
    {
      label: "Pending Approvals",
      value: 27,
      change: "5 from last 7 days",
      icon: "mdi:account-check-outline",
    },
    {
      label: "Pending Finance Verification",
      value: 9,
      change: "2 from last 7 days",
      icon: "mdi:currency-usd-circle-outline",
    },
  ],
  pendingActions: [
    {
      icon: "mdi:airplane",
      action: "Travel Requests Awaiting Approval",
      count: 18,
    },
    {
      icon: "mdi:file-document-outline",
      action: "Claims Awaiting Approval",
      count: 12,
    },
    {
      icon: "mdi:currency-usd-circle-outline",
      action: "Claims Awaiting Finance Verification",
      count: 9,
    },
    {
      icon: "mdi:swap-horizontal",
      action: "Budget Reallocation Requests",
      count: 5,
    },
    {
      icon: "mdi:folder-outline",
      action: "Documents Awaiting Acknowledgement",
      count: 7,
    },
  ],
  travelRequests: [
    {
      id: "TR-2025-0421",
      destination: "Singapore",
      date: "22 May 2025",
      status: "Pending Approval",
    },
    {
      id: "TR-2025-0420",
      destination: "Kuala Lumpur",
      date: "20 May 2025",
      status: "Draft",
    },
    {
      id: "TR-2025-0419",
      destination: "Bangkok",
      date: "14 May 2025",
      status: "Submitted",
    },
    {
      id: "TR-2025-0418",
      destination: "Kuching",
      date: "07 May 2025",
      status: "Approved",
    },
    {
      id: "TR-2025-0417",
      destination: "Penang",
      date: "29 Apr 2025",
      status: "Pending Approval",
    },
  ],
  claims: [
    {
      id: "CL-2025-0330",
      travelRef: "TR-2025-0421",
      amount: "1,250.00",
      status: "Pending Approval",
    },
    {
      id: "CL-2025-0329",
      travelRef: "TR-2025-0420",
      amount: "820.00",
      status: "Pending Finance",
    },
    {
      id: "CL-2025-0328",
      travelRef: "TR-2025-0419",
      amount: "1,100.00",
      status: "Draft",
    },
    {
      id: "CL-2025-0327",
      travelRef: "TR-2025-0418",
      amount: "2,340.00",
      status: "Approved",
    },
    {
      id: "CL-2025-0326",
      travelRef: "TR-2025-0417",
      amount: "950.00",
      status: "Paid",
    },
  ],
  upcomingTrips: [
    {
      id: "TR-2025-0421",
      destination: "Singapore",
      date: "22 May 2025",
      days: 4,
    },
    {
      id: "TR-2025-0419",
      destination: "Bangkok",
      date: "14 May 2025",
      days: 5,
    },
    {
      id: "TR-2025-0418",
      destination: "Kuching",
      date: "07 May 2025",
      days: 3,
    },
    {
      id: "TR-2025-0417",
      destination: "Penang",
      date: "29 Apr 2025",
      days: 3,
    },
    {
      id: "TR-2025-0416",
      destination: "Johor Bahru",
      date: "26 Apr 2025",
      days: 2,
    },
  ],
  budget: [
    {
      label: "Airfare",
      budget: 430,
      actual: 285,
    },
    {
      label: "Accommodation",
      budget: 315,
      actual: 225,
    },
    {
      label: "Subsistence",
      budget: 260,
      actual: 185,
    },
    {
      label: "Local Transport",
      budget: 160,
      actual: 115,
    },
    {
      label: "Others",
      budget: 100,
      actual: 55,
    },
  ],
  approvalSummary: [
    {
      label: "Pending Approval",
      count: 27,
      color: "#F5A400",
      badgeBg: "#FFF0D0",
      badgeText: "#C27803",
    },
    {
      label: "Returned for Amendment",
      count: 6,
      color: colors.state.warning,
      badgeBg: "#FFE8D8",
      badgeText: "#C4510C",
    },
    {
      label: "Approved",
      count: 41,
      color: "#049A68",
      badgeBg: "#DDF4E7",
      badgeText: "#067647",
    },
    {
      label: "Rejected",
      count: 3,
      color: colors.state.danger,
      badgeBg: "#FFE0E4",
      badgeText: "#C8232C",
    },
    {
      label: "Exception / Override Review",
      count: 4,
      color: "#0A6ED1",
      badgeBg: "#DDEBFF",
      badgeText: "#1264C8",
    },
  ],
};

const StatusBadge = ({ status }) => {
  const style = statusStyles[status] || statusStyles.Draft;

  return (
    <span
      className="bes-status-badge"
      style={{ color: style.color, backgroundColor: style.background }}
    >
      {status}
    </span>
  );
};

const TableLink = ({ children }) => (
  <button className="bes-table-link" type="button">
    <span>{children}</span>
    <Icon icon="mdi:chevron-right" width="20" height="20" />
  </button>
);

const DashboardHeader = () => {
  return (
    <div className="bes-dashboard-header">
      <h1>Dashboard</h1>

      <div className="bes-header-actions">
        <div className="bes-profile">
          <div className="bes-profile-avatar">AR</div>
          <div className="bes-profile-copy">
            <strong>Ahmad Ridhwan</strong>
            <span>Finance Officer</span>
          </div>
          <Icon icon="mdi:chevron-down" width="22" height="22" />
        </div>
      </div>
    </div>
  );
};

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: "Create Travel Request",
      icon: "mdi:plus",
      variant: "primary",
      path: "/travel/create",
    },
    {
      label: "Submit Claim",
      icon: "mdi:clipboard-text-outline",
      path: "/claim/create",
    },
    {
      label: "View Approvals",
      icon: "mdi:check-circle-outline",
      path: "/approval",
    },
  ];

  return (
    <div className="bes-quick-actions">
      {actions.map((action) => (
        <button
          className={`bes-action-button ${
            action.variant === "primary" ? "is-primary" : ""
          }`}
          key={action.label}
          type="button"
          onClick={() => navigate(action.path)}
        >
          <Icon icon={action.icon} width="24" height="24" />
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};

const SummaryCards = () => {
  return (
    <div className="bes-summary-grid">
      {dashboardData.summary.map((item) => (
        <article className="bes-summary-card" key={item.label}>
          <div className="bes-summary-icon">
            <Icon icon={item.icon} width="46" height="46" />
          </div>

          <div>
            <p>{item.label}</p>
            <strong>{item.value}</strong>
            <span>
              <Icon icon="mdi:triangle" width="9" height="9" />
              {item.change}
            </span>
          </div>
        </article>
      ))}
    </div>
  );
};

const PendingActionsPanel = () => (
  <section className="bes-panel bes-pending-panel">
    <h2>My Pending Actions</h2>
    <div className="bes-table-scroll">
        <table className="bes-table bes-pending-table">
        <thead>
            <tr>
            <th>Action</th>
            <th className="align-right">Count</th>
            </tr>
        </thead>
        <tbody>
            {dashboardData.pendingActions.map((item) => (
            <tr key={item.action}>
                <td className="bes-action-cell">
                <Icon icon={item.icon} width="22" height="22" />
                <span>{item.action}</span>
                </td>
                <td className="align-right">
                <span className="bes-count-pill">{item.count}</span>
                </td>
            </tr>
            ))}
        </tbody>
        </table>
    </div>
    <TableLink>View all actions</TableLink>
  </section>
);

const TravelRequestsPanel = () => (
  <section className="bes-panel">
    <h2>Recent Travel Requests</h2>
    <div className="bes-table-scroll">
        <table className="bes-table bes-travel-table">
        <thead>
            <tr>
            <th>Request ID</th>
            <th>Destination</th>
            <th>Travel Date</th>
            <th>Status</th>
            </tr>
        </thead>
        <tbody>
            {dashboardData.travelRequests.map((item) => (
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.destination}</td>
                <td>{item.date}</td>    
                <td>
                <StatusBadge status={item.status} />
                </td>
            </tr>
            ))}
        </tbody>
        </table>
    </div>
    <TableLink>View all travel requests</TableLink>
  </section>
);

const ClaimsPanel = () => (
  <section className="bes-panel">
    <h2>Recent Claims</h2>
    <div className="bes-table-scroll">
        <table className="bes-table bes-claims-table">
        <thead>
            <tr>
            <th>Claim ID</th>
            <th>Travel Ref</th>
            <th>Amount (MYR)</th>
            <th>Status</th>
            </tr>
        </thead>
        <tbody>
            {dashboardData.claims.map((item) => (
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.travelRef}</td>
                <td>{item.amount}</td>
                <td>
                <StatusBadge status={item.status} />
                </td>
            </tr>
            ))}
        </tbody>
        </table>
    </div>
    <TableLink>View all claims</TableLink>
  </section>
);

const UpcomingTripsPanel = () => (
  <section className="bes-panel">
    <h2>Upcoming Trips</h2>
    <div className="bes-table-scroll">
        <table className="bes-table bes-trips-table">
        <thead>
            <tr>
            <th>Request ID</th>
            <th>Destination</th>
            <th>Travel Date</th>
            <th className="align-right">Days</th>
            </tr>
        </thead>
        <tbody>
            {dashboardData.upcomingTrips.map((item) => (
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.destination}</td>
                <td>{item.date}</td>
                <td className="align-right">{item.days}</td>
            </tr>
            ))}
        </tbody>
        </table>
    </div>

    <TableLink>View all upcoming trips</TableLink>
  </section>
);

const BudgetPanel = () => {
  const maxValue = 500;

  return (
    <section className="bes-panel bes-budget-panel">
      <h2>Budget vs Actual Snapshot (Year to Date)</h2>

      <div className="bes-chart-legend">
        <span>
          <i className="legend-square is-budget" />
          Budget (MYR)
        </span>
        <span>
          <i className="legend-square is-actual" />
          Actual (MYR)
        </span>
      </div>

      <div className="bes-bar-chart">
        <div className="bes-chart-scale">
          <span>500k</span>
          <span>400k</span>
          <span>300k</span>
          <span>200k</span>
          <span>100k</span>
          <span>0</span>
        </div>

        <div className="bes-chart-plot">
          <div className="grid-line" />
          <div className="grid-line" />
          <div className="grid-line" />
          <div className="grid-line" />
          <div className="grid-line" />
          <div className="grid-line" />

          {dashboardData.budget.map((item) => (
            <div className="bes-chart-group" key={item.label}>
              <div className="bes-bar-pair">
                <span
                  className="bes-bar is-budget"
                  style={{ height: `${(item.budget / maxValue) * 100}%` }}
                />
                <span
                  className="bes-bar is-actual"
                  style={{ height: `${(item.actual / maxValue) * 100}%` }}
                />
              </div>
              <span className="bes-chart-label">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <TableLink>View detailed budget report</TableLink>
    </section>
  );
};

const ApprovalSummaryPanel = () => (
  <section className="bes-panel bes-approval-panel">
    <h2>Approval Summary</h2>

    <table className="bes-table bes-summary-table">
      <thead>
        <tr>
          <th>Status</th>
          <th className="align-right">Count</th>
        </tr>
      </thead>
      <tbody>
        {dashboardData.approvalSummary.map((item) => (
          <tr key={item.label}>
            <td>
              <span
                className="bes-dot"
                style={{ backgroundColor: item.color }}
              />
              {item.label}
            </td>
            <td className="align-right">
              <span
                className="bes-approval-count"
                style={{ color: item.badgeText, backgroundColor: item.badgeBg }}
              >
                {item.count}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    <TableLink>View approval report</TableLink>
  </section>
);

const Dashboard = () => {
  return (
    <React.Fragment>
      <DashboardHeader />

      <main
        className="bes-dashboard-page"
        style={{
          "--bes-primary": colors.brand.primary,
          "--bes-accent": colors.brand.accent,
          "--bes-text": colors.brand.primary,
          "--bes-muted": colors.neutral.disabled,
          "--bes-border": "#D7DDE7",
          "--bes-font": typography.fontFamily,
        }}
      >
        <QuickActions />
        <SummaryCards />

        <div className="bes-dashboard-grid">
          <PendingActionsPanel />
          <TravelRequestsPanel />
          <ClaimsPanel />
          <UpcomingTripsPanel />
          <BudgetPanel />
          <ApprovalSummaryPanel />
        </div>
      </main>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { loginError } = state.Login;
  return {
    loginError,
    dashboardInfo: state.Dashboard.dashboardInfo?.data,
    userPermission: state.Login.permissionArry,
  };
};

export default connect(mapStatetoProps)(Dashboard);
